<template>
    <div class="wrap">
        <div class="kv">
        </div>

        <div class="item">
            <span>题目</span>
            <input type="text" placeholder="请输入题目" v-model="work.title">
        </div>

        <div class="item" >
              <span>病例</span>
              <img id="file" src="../../assets/img/file.png" v-if="work.caseId!=-1" >
              <img id="plus" src="../../assets/img/plus.png" v-if="work.caseId==-1" @click="chooseFile">
              <input  class="fileChoose" type="file" accept="application/msword"  multiple="multiple" @change="fileUpload" ref="fileUpload" v-if="work.caseId==-1||work.caseId==''">
              <a :href="work.href" v-if="work.href!=''" style="width: 35px ;height: 35px ;position: absolute; left: 20%;opacity: 0 ;margin: auto 0">开始下载</a>
              <label v-if="work.caseId==-1||work.caseId==''">{{work.fileName}}</label>
              <a href="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/征集模板.doc" v-if="work.caseId==-1" style="margin: auto 20px;font-size: 15px;">模板下载</a>
              <a href="javascript:void(0);" style="margin: auto 0" @click="reload" v-if="again==0">重新上传</a>
              <input id="fileChoose" type="file" accept="application/msword" v-show="false"  @change="uploadAgain" ref="uploadAgain">
              <label class="chooseAgain" v-if="again==0">{{sFileName}}</label>

        </div>

        <div class="comment-title" v-if="work.caseId!=-1&&work.caseId!=''&&again!=0">
            <span >评价</span>
        </div>

        <div v-for="(item,index) in scores" v-bind:key="index">
            <div class="item" v-if="work.caseId!=-1&&work.caseId!=''">
                <span>得分{{index+1}}</span>
                <label>{{item.score}}分</label>
            </div>

            <div class="item" v-if="work.caseId!=-1&&work.caseId!=''">
                <span>评语{{index+1}}</span>
                <label>{{item.comment}}</label>
            </div>
            <hr style="width: 95%">
        </div>


        <div class="submit-wrap" @click="submit" v-if="work.caseId==-1||work.caseId==''||again==0">
            <label >{{btnSubmit}}</label>
        </div>

    </div>
</template>

<script>
    import OSS from 'ali-oss';
    import {getUuid} from "@/assets/util/util";
    import {getOssSecret,wxAddCase,wxGetCaseById} from "@/assets/js/api";
    import { Indicator } from 'mint-ui';

    export default {
        name: '',
        data() {
            return {
                btnSubmit:"提交",
                chooseFile:"请选择文件",
                docId:this.$store.state.docId,
                again:this.$route.query.again,
                ossPrefix:"wxsw/",
                sFileName:"",
                work:{
                    caseId:this.$route.query.caseId,
                    title:"",
                    file:"",
                    href:"",
                    fileName:"请上传word文件",
                },
                scores:[]
            }
        },
        mounted(){
            console.log(this.work.caseId,"caseId====")
            if(this.again==0){
                this.btnSubmit = "重新提交"
            }
            if(this.work.caseId!=-1){
                this.getCaseById(this.work.caseId)
            }
            this.getSecret();
        },
        methods: {
            reload(){
                // this.$toast("start reload!!!")
                document.getElementById("fileChoose").click()
            },
            async getCaseById(caseId){
                console.log("---获取对方---")
                let res = await wxGetCaseById({caseId});

                this.work = res.data.data.case
                // this.scores = res.data.data.scores

                console.log(res)
            },
            submit:function () {
                if(!this.work.title){
                    this.$toast("题目不能为空")
                    return;
                }

                if(this.again==0&&this.sFileName==""){
                    this.$toast("请重新上传病例")
                    return;
                }

                if(!this.work.file){
                    this.$toast("请选择病例")
                    return;
                }
                //开始提交文件
                this.ossUpload(this.work.file)
            },

            fileUpload:function (event) {
                this.work.file = event.target.files[0]
                this.work.fileName = event.target.files[0].name
                // this.$set(this.work,"caseId","12")
                // this.work["caseId"] = ""
            },

            uploadAgain:function (event) {
                this.work.file = event.target.files[0]
                this.sFileName = event.target.files[0].name
                // this.caseId = ""
            },

            async ossUpload(file){
                let client = new OSS({
                    region: 'oss-cn-beijing',
                    accessKeyId: 'LTAINtmi5XZ7NaV5',
                    accessKeySecret: this.ossKeySecret,
                    bucket: 'ymd-lcc'
                })

                Indicator.open({
                    text: '上传中',
                    spinnerType: 'fading-circle'
                });

                let uuid = getUuid()
                uuid+=("."+file.name.split(".")[1])
                let key = this.ossPrefix + uuid
                const _this = this
                await client.put(key, file).then(function (res) {
                    let str = res.res.requestUrls[0]
                    let status = res.res.status
                    if(status == 200){
                        let link =  str.split("?")[0];
                        _this.addCase(_this.docId,_this.work.title,link,_this.work.caseId)
                        Indicator.close();
                    }else {
                        this.$toast("上传失败")
                    }
                }).catch((err) => {
                    console.log(err,"异常啦")
                    this.$toast("获取适配失败，请稍后重试")
                })
            },
            async getSecret(){
                const res = await getOssSecret();
                console.log(res,"secret res")
                if(res.data.success==true){
                    this.ossKeySecret = res.data.data.accessKeySecret;
                }
            },
            async addCase(docId,title,href,caseId){
                    const res = await wxAddCase({docId,title,href,caseId})
                    if(res.data.success ==true){
                        this.$toast("提交成功")
                        this.$router.push({path:"/wx_index"})
                    }else{
                        this.$toast(res.data.message)
                    }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .wrap {
        width: 100%;
        max-width: 500px;
        height: 100vh;
        display: flex;
        flex-direction: column;
        margin: 0 auto;
        overflow: auto;
        background: #FFF;
    }

    .kv{
        width: 100%;
        /*height: 100vw;*/
        padding: 56.25% 0 0;
        background: #FFF url("../../assets/img/wx_kv.jpg") no-repeat;
        background-size: 100% 100% ;
    }

    .item{
        position: relative;
        margin: 10px;
        display: flex;
        justify-content: left;
        font-size: 20px;
        span{
            width: 20%;
            margin: auto 0;
            font-size: 18px;
        }
        input{
            text-indent: 5px;
            width: 35px;
            height: 35px;
            flex: 1;
            outline: none;
            border: transparent;
            border-radius: 5px;
            background: #e0e0e0;
        }
        label{
            width: 70%;
            margin: auto 10px;
            text-align: left;
            font-size: 10px;
            flex: 1;
            white-space: pre-line;
            word-wrap: break-word;

        }
    }

    .float—wrap{
        position: absolute;
        right: 2%;
    }

    .fileChoose{
        width: 50px;
        height: 50px;
        position: absolute;
        left: 20%;
        opacity: 0;
        /*opacity: 0;*/
    }

    input::placeholder{
        font-size: 15px;
    }

    input{
        font-size: 15px;
    }

    img{
        width: 35px;
        height: 35px;
    }

    .comment-title{
        font-size: 20px;
        margin: 10px 0;
        padding: 5px;
        font-weight: bold;
        background: #dedede;
        text-align: left;
        span{
            margin-left: 10px;
        }
    }

    .submit-wrap{
        width: 80%;
        background: #0082c5;
        margin: 50px auto;
        padding: 5px 0;
        border-radius: 15px;
        color: #FFF;
        font-size: 18px;
    }

</style>
